import template from './stCookieSettings.html';
import controller from './stCookieSettings.controller';

let stCookieSettingsComponent = {
    restrict: 'E',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    template,
    controller,
    controllerAs: 'vm'
};

export default stCookieSettingsComponent;



// WEBPACK FOOTER //
// ./client/app/common/stCookieSettings/stCookieSettings.component.js